import React from "react";
import { useUi } from "@jelly/lesson";

interface StandardCaseProps {
  title: string;
  description?: string;
  leftComponent?: React.ReactNode;
  leftBlockWidth?: string;
  hideTitle?: boolean;
  children: React.ReactNode;
}

import styles from "./StandardCase.module.scss";

export const StandardCase: React.FC<StandardCaseProps> = (props) => {
  const { title, description, hideTitle, leftBlockWidth, leftComponent, children } = props;

  const Ui = useUi();

  let leftChild = leftComponent;
  if (!leftChild && description) {
    leftChild = (
      <p className={styles.description}>
        <Ui.Scrollbars>
          {description.split("\n").map((line) => (
            <>
              {line}
              <br />
            </>
          ))}
        </Ui.Scrollbars>
      </p>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.leftBlock} style={{ width: leftBlockWidth ? leftBlockWidth : undefined }}>
        {!hideTitle && <h1 className={styles.title}>{title}</h1>}
        {leftChild}
      </div>
      <div className={styles.rightBlock}>{children}</div>
    </div>
  );
};
